import { render, staticRenderFns } from "./UpdateMessage.vue?vue&type=template&id=7a735344&scoped=true&"
import script from "./UpdateMessage.vue?vue&type=script&lang=js&"
export * from "./UpdateMessage.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMessage.vue?vue&type=style&index=0&id=7a735344&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a735344",
  null
  
)

export default component.exports